import Header from '../../../../components/Header'
import { useEffect, useState } from 'react'
import api from '../../../../services/api';
import { toast } from 'react-toastify'
import BillsList from '../../../../components/BillsList';
import Footer from '../../../../components/Footer';

export default function Bills() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
   
  })

  return (
    <>
        <Header/>        
        <BillsList/>
        <Footer/>
    </>
  )
}